import React from 'react';

/**
 * Wordmark canônico: SUPER no tom do texto e VITRINE no acento da marca.
 *
 * As cores vêm de --sv-brand-word e --sv-brand-accent (index.css), que já têm
 * valor para o tema escuro, o claro e o /sistema. Tamanho, peso e espaçamento
 * ficam com quem usa, porque header, rodapé e sidebar pedem medidas diferentes.
 */
export default function MarcaTexto({ className = '', style }) {
    return (
        <span className={className} style={{ color: 'var(--sv-brand-word, var(--text))', ...style }} data-testid="brand-wordmark">
            SUPER<span style={{ color: 'var(--sv-brand-accent)' }}>VITRINE</span>
        </span>
    );
}
